import React from 'react';

import { MarketingTileGroup } from 'features/content/components/marketing-tile-group';
import { IMarketingTileGroupProps } from 'features/content/components/marketing-tile-group/types';

import { HomeMarketingCardGroup } from './home-marketing-card-group';

export const HomeMarketingTileGroup = (
  props: Omit<IMarketingTileGroupProps, 'CardGroupComponent'>
) => <MarketingTileGroup {...props} CardGroupComponent={HomeMarketingCardGroup} />;
